import {
  createSalaryApi,
  deleteSalaryApi,
  getAllSalaryApi,
  getSalaryByIdApi,
  updateSalaryApi,
} from "../../helpers/backend_helper";

import {
  errorMessages,
  getSalaryList,
  loadingData,
  salaryByIdData,
} from "./reducer";

export const getAllSalaryList = (currentPage, pageSize, search) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "read", value: true }));
    let response;
    response = getAllSalaryApi(currentPage, pageSize, search);
    const data = await response;
    dispatch(getSalaryList(data));
  } catch (error) {
    dispatch(errorMessages("Some thing went wrong, please try later"));
  } finally {
    dispatch(loadingData({ type: "read", value: false }));
  }
};

export const getSalaryById = (id) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "getById", value: true }));
    let response;
    response = getSalaryByIdApi(id);
    const data = await response;
    dispatch(salaryByIdData(data));
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
  } finally {
    dispatch(loadingData({ type: "getById", value: false }));
  }
};

export const createSalary = (data) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "create", value: true }));
    await createSalaryApi(data);
    return { success: true, message: "Salary Successfully Created" };
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
    return {
      success: false,
      message: errorMessage || "Failed to create salary",
    };
  } finally {
    dispatch(loadingData({ type: "create", value: false }));
  }
};

export const updateSalary = (id, data) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "update", value: true }));
    let response;
    response = await updateSalaryApi(id, data);
    return { success: true, message: "Salary Successfully Updated" };
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(errorMessages(errorMessage));
    return {
      success: false,
      message: errorMessage || "Failed to update salary",
    };
  } finally {
    dispatch(loadingData({ type: "update", value: false }));
  }
};

export const deleteSalary = (id) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "delete", value: true }));
    await deleteSalaryApi(id);
    return { success: true, message: "Salary Successfully Deleted" };
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
    return { success: false, message: errorMessage || "Failed to delete salary" };
  } finally {
    dispatch(loadingData({ type: "delete", value: false }));
  }
};
